import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Divider } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { hasSocialAuthConsent } from '../../../redux/core/consent/consentSlice.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useAppSelector } from '../../../redux/hooks.js';
import { SocialsWrapper } from '../../../components/SocialsWrapper/index.js';
import { SocialsWrapperDynamic } from '../../../components/SocialsWrapper/SocialsWrapperDynamic.js';
export const SocialButtonsContainer = () => {
    const { t } = useTranslation();
    const hasSocialAuthConsentAccepted = useAppSelector(hasSocialAuthConsent);
    return (_jsx(SocialsWrapper, { children: hasSocialAuthConsentAccepted && (_jsxs(_Fragment, { children: [_jsx(Divider, { mt: 'spaceS', mb: 'spaceS2', children: t('loginregistration.twoStepLoginRegistration.divider') }), _jsx(SocialsWrapperDynamic, {})] })) }));
};
//# sourceMappingURL=SocialButtonsContainer.js.map